import { jsx as _jsx } from "react/jsx-runtime";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
const { vendors: { GET_LABELS, SEARCH_LABELS } } = queries;
const { vendors: { DELETE_LABEL } } = mutations;
const LabelsList = () => (_jsx(List, { deleteMutation: DELETE_LABEL, hasSearch: true, itemNamePlural: "labels", label: "Labels", listQuery: GET_LABELS, listQueryDataName: "getLabels", pathPrefix: "/vendors", searchQuery: SEARCH_LABELS, searchQueryDataName: "searchLabels", searchQueryInputName: "searchLabelsInput", searchQueryPropertyName: "name" }));
export default LabelsList;
